var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label",class:{
        'label-pf': _vm.person_type === 1,
        'label-pfext': _vm.person_type === 2,
        'label-pm': _vm.person_type === 0,
        'label-pmext': _vm.person_type === 3,
        'label-finance-society': _vm.person_type === 4,
      }},[(_vm.person_type === 0)?[_vm._v("PM Mex")]:_vm._e(),(_vm.person_type === 1)?[_vm._v("PF Mex")]:_vm._e(),(_vm.person_type === 2)?[_vm._v("PF Ext")]:_vm._e(),(_vm.person_type === 3)?[_vm._v("PM Ext")]:_vm._e(),(_vm.person_type === 4)?[_vm._v("Entidad Financiera")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }